// hooks/useLanguageRTL.ts
import { useCallback } from 'react';

import { LangData } from '@/constants/language';
import { useLanguageList } from '@/hooks/useLanguageList';

/**
 * 指定された言語がRTL表示が必要かどうかを判定
 *
 * @param langCode 判定したい言語コード
 * @param langCodeList 言語データのリスト
 * @returns RTL表示が必要かどうか
 */
const isLanguageRTL = (
  langCode: string,
  langCodeList: LangData[] | undefined,
): boolean => {
  const langData: LangData | undefined = langCodeList?.find(
    (value) => value[langCode],
  );
  if (!langData) {
    return false;
  }

  return langData[langCode].rightToLeft;
};

/**
 * 選択中の翻訳元言語がRTL表示が必要かどうか管理するhooks
 *
 * @returns
 */
export const useLanguageRTL = () => {
  const { srcLangList, destLangList } = useLanguageList();

  /**
   * 選択中の翻訳元言語がRTL表示が必要かどうか
   */
  const isSrcLangRTL = useCallback(
    (currentSrclang: string): boolean =>
      isLanguageRTL(currentSrclang, srcLangList),
    [srcLangList],
  );

  /**
   * 選択中の翻訳先言語がRTL表示が必要かどうか
   */
  const isDestLangRTL = useCallback(
    (currentDestlang: string): boolean =>
      isLanguageRTL(currentDestlang, destLangList),
    [destLangList],
  );

  return { isSrcLangRTL, isDestLangRTL };
};